import { createStore } from 'vuex'

import phone from './modules/phone'
import stores from './modules/stores'
import places from './modules/places'
import prices from './modules/prices'
import products from './modules/products'
import takeBack from './modules/takeback'
import providers from './modules/providers'

export default createStore({
    modules: {
        phone,
        stores,
        places,
        prices,
        products,
        takeBack,
        providers
    }
})
